const HelpEventBus = new EventTarget()

const bindHelpDirective = {
    mounted(el) {
        attachListeners(el)
    },
    updated(el) {
        attachListeners(el)
    }
}

function attachListeners(container) {
    const links = container.querySelectorAll('.help-text');
    links.forEach(link => {
        if (!link.dataset.bound) {
            link.dataset.bound = 'true';

            // Add event listener
            link.addEventListener('click', e => {
                e.preventDefault()
                const id = link.getAttribute('data-id')
                HelpEventBus.dispatchEvent(new CustomEvent('open-help', { detail: { id } }))
            })

            // Adjust SVG color
            const svg = link.querySelector('svg');
            if (svg) {
                // Inherit color
                svg.setAttribute('fill', 'currentColor');

                // Set to scale with text
                svg.setAttribute('width', '1em')
                svg.setAttribute('height', '1em')
            }
        }
    })
}

export { bindHelpDirective, HelpEventBus }
